import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const BudgetsSecondaryViewStore = GenericFieldFactory("BUDGETS_SECONDARY_VIEW", null);